import { max } from "moment/moment";

export const FIELD_CONFIG = {
  broker_id: {
    type: "number",
    label: "Broker ID #",
    required: false,
    col: 6,
    fieldName: "broker_id",
  },
  broker_name: {
    type: "text",
    label: "Broker Name",
    required: false,
    col: 6,
    fieldName: "broker_name",
    max: 100
  },
  case_analysis: {
    type: "textarea",
    label: "Case Analysis",
    required: false,
    col: 12,
    fieldName: "case_analysis",
    max: 65000
  },
  case_fact: {
    type: "textarea",
    label: "Case Facts",
    required: false,
    col: 12,
    fieldName: "case_fact",
    max: 65000
  },
  case_name: {
    type: "text",
    label: "Case Name",
    required: false,
    col: 6,
    fieldName: "case_name",
  },
  case_concern_to_sm: {
    type: "select",
    label: "Case of Concern to Senior Management? (Y/N)",
    required: false,
    col: 6,
    fieldName: "case_concern_to_sm",
    options: [
      { value: "Y", label: "Yes" },
      { value: "N", label: "No" },
    ],
  },
  ctt_or_cts: {
    type: "select",
    label: "Case to Try, Case TBD or Case to Settle",
    required: false,
    col: 6,
    fieldName: "ctt_or_cts",
    options: [
      { value: "CTT", label: "Case to Try" },
      { value: "CTBD", label: "Case TBD" },
      { value: "CTS", label: "Case to Settle" },
    ],
  },
  claim_adjuster: {
    type: "text",
    label: "Claim Adjuster",
    required: false,
    col: 6,
    fieldName: "claim_adjuster",
  },
  claim_number: {
    type: "text",
    label: "Claim Number",
    required: false,
    col: 6,
    fieldName: "claim_number",
  },
  claim_status: {
    type: "select",
    label: "Claim Status (Open/Closed)",
    required: false,
    col: 6,
    fieldName: "claim_status",
    options: [
      { value: "OP", label: "Open" },
      { value: "CL", label: "Closed" },
      { value: "RO", label: "Reopened" },
    ],
  },
  claim_type: {
    type: "select",
    label: "Claim Type",
    required: false,
    col: 6,
    fieldName: "claim_type",
    options: [
      { value: "NY-LL", label: "NY-LL" },
      { value: "BI", label: "BI" },
      { value: "PD", label: "PD" },
    ],
  },
  claimant_name: {
    type: "text",
    label: "Claimant Name",
    required: false,
    col: 6,
    fieldName: "claimant_name",
  },
  date_of_loss: {
    type: "date",
    label: "Date of Loss",
    required: false,
    col: 6,
    fieldName: "date_of_loss",
  },
  date_of_loss_notes: {
    type: "textarea",
    label: "Date of Loss Notes",
    required: false,
    col: 12,
    fieldName: "date_of_loss_notes",
    max: 65000,
  },
  expense_incurred: {
    type: "number",
    label: "Expense - Incurred",
    required: false,
    col: 6,
    fieldName: "expense_incurred",
  },
  expense_outstanding: {
    type: "number",
    label: "Expense - Outstanding",
    required: false,
    col: 6,
    fieldName: "expense_outstanding",
  },
  expense_paid: {
    type: "number",
    label: "Expense Paid",
    required: false,
    col: 6,
    fieldName: "expense_paid",
  },
  firm_matter_number: {
    type: "text",
    label: "Firm Matter Number",
    required: false,
    col: 6,
    fieldName: "firm_matter_number",
  },
  bodily_injury_incurred: {
    type: "number",
    label: "Bodily Injury - Incurred",
    required: false,
    col: 6,
    fieldName: "bodily_injury_incurred",
  },
  bodily_injury_outstanding: {
    type: "number",
    label: "Bodily Injury - Outstanding",
    required: false,
    col: 6,
    fieldName: "bodily_injury_outstanding",
  },
  bodily_injury_paid: {
    type: "number",
    label: "Bodily Injury - Paid",
    required: false,
    col: 6,
    fieldName: "bodily_injury_paid",
  },
  property_damage_incurred: {
    type: "number",
    label: "Property Damage - Incurred",
    required: false,
    col: 6,
    fieldName: "property_damage_incurred",
  },
  property_damage_outstanding: {
    type: "number",
    label: "Property Damage - Outstanding",
    required: false,
    col: 6,
    fieldName: "property_damage_outstanding",
  },
  property_damage_paid: {
    type: "number",
    label: "Property Damage Paid",
    required: false,
    col: 6,
    fieldName: "property_damage_paid",
  },
  indemnity_incurred: {
    type: "number",
    label: "Indemnity (WC) - Incurred",
    required: false,
    col: 6,
    fieldName: "indemnity_incurred",
  },
  indemnity_outstanding: {
    type: "number",
    label: "Indemnity (WC) - Outstanding",
    required: false,
    col: 6,
    fieldName: "indemnity_outstanding",
  },
  indemnity_paid: {
    type: "number",
    label: "Indemnity (WC) - Paid",
    required: false,
    col: 6,
    fieldName: "indemnity_paid",
  },
  injury_loss: {
    type: "textarea",
    label: "Injury/Damages",
    required: false,
    col: 12,
    fieldName: "injury_loss",
    max: 65000,
  },
  insured_defendant_name: {
    type: "text",
    label: "Insured Defendant Name(s)",
    required: false,
    col: 12,
    fieldName: "insured_defendant_name",
  },
  litigation_phase: {
    type: "select",
    label: "Litigation Phase (In Discovery/Deposition, etc)",
    required: false,
    col: 6,
    fieldName: "litigation_phase",
     options: [
      { value: "Pleadings", label: "Pleadings" },
      { value: "Paper discovery", label: "Paper discovery" },
      { value: "Examination before trial", label: "Examination before trial" },
      { value: "IME and Expert Disclosure", label: "IME and Expert Disclosure" },
      { value: "Note of issue filed", label: "Note of issue filed" },
      { value: "Summary Judgement", label: "Summary Judgement" },
      { value: "Mediation/Settlement Discussions", label: "Mediation/Settlement Discussions" },
      { value: "Trial", label: "Trial" },
      { value: "Post-Trials Motions", label: "Post-Trials Motions" },
      { value: "Appeal", label: "Appeal" },
      { value: "Settlement Finalized/Judgement", label: "Settlement Finalized/Judgement" }
    ],
  },
  loss_description: {
    type: "textarea",
    label: "Loss Description",
    required: false,
    col: 12,
    fieldName: "loss_description",
    max: 65000,
  },
  medical_provider: {
    type: "textarea",
    label: "Medical Provider(s)",
    required: false,
    col: 12,
    fieldName: "medical_provider",
    max: 1000,
  },
  plaintiff_attorny: {
    type: "text",
    label: "Plaintiff Attorney",
    required: false,
    col: 6,
    fieldName: "plaintiff_attorny",
    max: 100
  },
  plaintiff_law_firm: {
    type: "text",
    label: "Plaintiff Law Firm",
    required: false,
    col: 6,
    fieldName: "plaintiff_law_firm",
  },
  policy_number: {
    type: "text",
    label: "Policy Number",
    required: false,
    col: 12,
    fieldName: "policy_number",
    max: 100
  },
   effective_date: {
    type: "date",
    label: "Effective Date",
    required: false,
    col: 6,
    fieldName: "effective_date",
  },
   expiration_date: {
    type: "date",
    label: "Expiration Date",
    required: false,
    col: 6,
    fieldName: "expiration_date",
  },
  reverse_increase_requested: {
    type: "select",
    label: "Reserve Increase Requested (Y/N?)",
    required: false,
    col: 6,
    fieldName: "reverse_increase_requested",
    options: [
      { value: "Y", label: "Yes" },
      { value: "N", label: "No" },
    ],
  },
  surgeon: {
    type: "text",
    label: "Surgeon(s)",
    required: false,
    col: 6,
    fieldName: "surgeon",
  },
  tradesman_comments: {
    type: "textarea",
    label: "Tradesman Comments",
    required: false,
    col: 12,
    fieldName: "tradesman_comments",
    max: 65000,
  },
  trail_date: {
    type: "date",
    label: "Trial Date",
    required: false,
    col: 6,
    fieldName: "trail_date",
  },
  trail_information: {
    type: "textarea",
    label: "Trial Information",
    required: false,
    col: 12,
    fieldName: "trail_information",
    max: 250,
  },
  venue: {
    type: "text",
    label: "Venue",
    required: false,
    col: 6,
    fieldName: "venue",
  },
  defense_counsel: {
    type: "text",
    label: "Defense Counsel",
    required: false,
    col: 6,
    fieldName: "defense_counsel",
  },
  accident_state: {
    type: "text",
    label: "Accident State",
    required: false,
    col: 6,
    fieldName: "accident_state",
  },
  work_comp_lien: {
    type: "textarea",
    label: "Work Comp Lien",
    required: false,
    col: 12,
    fieldName: "work_comp_lien",
    max: 250
  },
  total_amount_medicals: {
    type: "number",
    label: "Total Amount Medicals",
    required: false,
    col: 6,
    fieldName: "total_amount_medicals",
  },
  other_demages: {
    type: "textarea",
    label: "Other Damages",
    required: false,
    col: 12,
    fieldName: "other_demages",
    max: 250
  },
  layer_aditional_comments: {
    type: "textarea",
    label: "Lawyer Additional Comments",
    required: false,
    col: 12,
    fieldName: "layer_aditional_comments",
    max: 5000000,
  },
  settlement_value: {
    type: "text",
    label: "Settlement Value",
    required: false,
    col: 6,
    fieldName: "settlement_value",
  },
  verdict_value: {
    type: "text",
    label: "Verdict Value",
    required: false,
    col: 6,
    fieldName: "verdict_value",
  },
  propose_reserve_increase: {
    type: "number",
    label: "Proposed Reserve Increase",
    required: false,
    col: 6,
    fieldName: "propose_reserve_increase",
  },
  first_chair: {
    type: "text",
    label: "1st Chair",
    required: false,
    col: 6,
    fieldName: "1st_chair",
  },
  second_chair: {
    type: "text",
    label: "2nd Chair",
    required: false,
    col: 6,
    fieldName: "2nd_chair",
  },
  potential_case: {
    type: "select",
    label: "Potential 240(1) Case",
    required: false,
    col: 6,
    fieldName: "potential_case",
    options: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  },
  industrial_code_voilation_alleged: {
    type: "text",
    label: "Industrial Code Violation Alleged",
    required: false,
    col: 12,
    fieldName: "industrial_code_voilation_alleged",
  },
  industrial_code_voilation_opinion: {
    type: "text",
    label: "Is there a Violation of the Industrial Code In Your Opinion",
    required: false,
    col: 12,
    fieldName: "industrial_code_voilation_opinion",
  },
  // Exposure Assessment Fields
  // exposure_100k: {
  //   type: "select",
  //   label: "Exposure $100K",
  //   required: false,
  //   col: 6,
  //   fieldName: "exposure_100k",
  //   options: [
  //     { value: "YES", label: "Yes" },
  //     { value: "NO", label: "No" },
  //     { value: "TBD", label: "TBD" },
  //     { value: "UNKNOWN", label: "Unknown" },
  //   ],
  // },
  // exposure_250k: {
  //   type: "select",
  //   label: "Exposure $250K",
  //   required: false,
  //   col: 6,
  //   fieldName: "exposure_250k",
  //   options: [
  //     { value: "YES", label: "Yes" },
  //     { value: "NO", label: "No" },
  //     { value: "TBD", label: "TBD" },
  //     { value: "UNKNOWN", label: "Unknown" },
  //   ],
  // },
  // exposure_500k: {
  //   type: "select",
  //   label: "Exposure $500K",
  //   required: false,
  //   col: 6,
  //   fieldName: "exposure_500k",
  //   options: [
  //     { value: "YES", label: "Yes" },
  //     { value: "NO", label: "No" },
  //     { value: "TBD", label: "TBD" },
  //     { value: "UNKNOWN", label: "Unknown" },
  //   ],
  // },
  // exposure_1m: {
  //   type: "select",
  //   label: "Exposure $1M",
  //   required: false,
  //   col: 6,
  //   fieldName: "exposure_1m",
  //   options: [
  //     { value: "YES", label: "Yes" },
  //     { value: "NO", label: "No" },
  //     { value: "TBD", label: "TBD" },
  //     { value: "UNKNOWN", label: "Unknown" },
  //   ],
  // },
  potential_240_case: {
    type: "select",
    label: "Potential 240 Case",
    required: false,
    col: 6,
    fieldName: "potential_240_case",
    options: [
      { value: "YES", label: "Yes" },
      { value: "NO", label: "No" },
      { value: "TBD", label: "TBD" },
      { value: "UNKNOWN", label: "Unknown" },
    ],
  },
  industrial_code_violation_alleged: {
    type: "select",
    label: "Industrial Code Violation Alleged",
    required: false,
    col: 6,
    fieldName: "industrial_code_violation_alleged",
    options: [
      { value: "YES", label: "Yes" },
      { value: "NO", label: "No" },
      { value: "TBD", label: "TBD" },
      { value: "UNKNOWN", label: "Unknown" },
    ],
  },
  industrial_code_violation_opinion: {
    type: "select",
    label: "Industrial Code Violation Opinion",
    required: false,
    col: 6,
    fieldName: "industrial_code_violation_opinion",
    options: [
      { value: "YES", label: "Yes" },
      { value: "NO", label: "No" },
      { value: "TBD", label: "TBD" },
      { value: "UNKNOWN", label: "Unknown" },
    ],
  },
  is_fraudulent: {
    type: "toggle",
    label: "Mark as Fraudulent",
    required: false,
    col: 6,
    fieldName: "is_fraudulent",
  },
  address_id: {
    type: "address",
    label: "Address",
    required: false,
    col: 12,
    fieldName: "address_id",
  },
};
export default FIELD_CONFIG;
